module.exports = __webpack_public_path__ + "static/counter_bg-e694afc694ba5413f1618b456b4e5597.svg";